var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    { class: { "info-visible": _vm.infoVisible } },
    [
      _c(
        "tr",
        {
          staticClass: "prospectus-row",
          attrs: {
            "aria-expanded": _vm.infoVisible ? "true" : "false",
            tabindex: "0"
          },
          on: {
            keyup: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.toggleInfoVisibility($event)
            },
            click: _vm.toggleInfoVisibility
          }
        },
        [
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.prospectus.companies
                  .map(function(x) {
                    return x.companyName
                  })
                  .join(", ")
              )
            )
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(_vm._s(_vm.FormatDate(_vm.prospectus.approvalDate)))
          ]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.translatedInfo(_vm.prospectus)))]),
          _vm._v(" "),
          _vm.prospectus.prospectusType !== 4
            ? _c("td", [_vm._v(_vm._s(_vm.prospectus.nationalIdentifier))])
            : _vm._e(),
          _vm._v(" "),
          _vm.prospectus.prospectusType === 4
            ? _c("td", [
                _vm._v(_vm._s(_vm.FormatDate(_vm.prospectus.notificationDate)))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.prospectusTypesWithListing.includes(_vm.prospectus.prospectusType)
            ? _c("td", [_vm._v(_vm._s(_vm.YesNo(_vm.prospectus.listed)))])
            : _vm.prospectusTypesWithListing.includes(
                _vm.lastSearchParams.ProspectusType
              ) || !_vm.lastSearchParams.ProspectusType
            ? _c("td")
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.infoVisible
        ? _c("prospectus-item-info", { attrs: { prospectus: _vm.prospectus } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-714d29f9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714d29f9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/Prospectus3Page/src/ProspectusItem.vue
// module id = 301
// module chunks = 1